// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Layout-module--wrap--3n_F0","body":"Layout-module--body--3Ji3c"};